export enum DeliveryFeedBacks {
  DELIVERED = 'DELIVERED',
  NOT_DELIVERED = 'NOT_DELIVERED',
}

export enum DELIVERED_CHIPS {
  POOR_SERVICE_QUALITY = 'کیفیت نامناسب خدمات',
  POOR_SUPPORT = 'پشتیبانی ضعیف',
  STORE_VIOLATION = 'تخلف فروشگاه',
  STORE_HIGH_PRICES = 'قیمت‌های بالای فروشگاه',
  DIFFICULT_PURCHASE_PROCESS = 'راحت نبودن فرایند خرید',
  OTHER = 'دلایل دیگر',
}

export enum NOT_DELIVERED_CHIPS {
  LATE_DELIVERY = 'تاخیر در سفارش',
  CANCEL_ORDER = 'لغو سفارش',
  DELIVERY_DATE_NOT_MET = 'نرسیدن موعد تحویل',
}

export enum RatePurchaseTypes {
  ONLINE = 'ONLINE',
  OFFLINE = 'OFFLINE',
}

export enum PaymentChannels {
  API = 0,
  UPG = 1,
  SMART_POS = 2,
  QR = 3,
  ESCROW = 4,
  BARCODE = 5,
  LINUX_POS = 6,
  APP = 7,
}
